module.exports = __webpack_public_path__ + "img/sync_circle.d0f8234f.svg";